import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/edit.png'
import _imports_1 from '../../assets/icons/delete.png'
import _imports_2 from '../../assets/icons/mail.png'
import _imports_3 from '../../assets/icons/phone.png'
import _imports_4 from '../../assets/icons/internet.png'
import _imports_5 from '../../assets/icons/pin.png'


const _withScopeId = n => (_pushScopeId("data-v-653d54ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-displayer-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-icon" }, "📞", -1))
const _hoisted_4 = { class: "empty-text" }
const _hoisted_5 = { class: "contact-card" }
const _hoisted_6 = { class: "contact-header" }
const _hoisted_7 = { class: "contact-title" }
const _hoisted_8 = {
  key: 0,
  class: "contact-actions"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Edit",
  class: "w-4 h-4 filter-main"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Delete",
  class: "w-4 h-4 filter-main"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "contact-details"
}
const _hoisted_16 = {
  key: 0,
  class: "contact-field"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Email",
  class: "field-icon-img filter-main"
}, null, -1))
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 1,
  class: "contact-field"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "Phone",
  class: "field-icon-img filter-main"
}, null, -1))
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 2,
  class: "contact-field"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "Website",
  class: "field-icon-img filter-main"
}, null, -1))
const _hoisted_24 = ["href"]
const _hoisted_25 = {
  key: 3,
  class: "contact-field"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "Address",
  class: "field-icon-img filter-main"
}, null, -1))
const _hoisted_27 = { class: "field-value" }
const _hoisted_28 = {
  key: 1,
  class: "no-contact-info"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bu kişi için detaylı iletişim bilgisi bulunmuyor.", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 2,
  class: "qr-button-container"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "qr-header" }
const _hoisted_34 = { class: "qr-content" }
const _hoisted_35 = { class: "qr-code-container" }
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = { class: "qr-instructions" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "qr-title" }, "📱 Bu QR kodu tarayarak iletişim bilgilerini telefonunuza ekleyebilirsiniz", -1))
const _hoisted_39 = { class: "qr-details" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "QR kod içeriği:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "İsim:", -1))
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Şirket:", -1))
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "E-posta:", -1))
const _hoisted_46 = { key: 2 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Telefon:", -1))
const _hoisted_48 = { key: 3 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Adres:", -1))
const _hoisted_50 = { key: 4 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Website:", -1))
const _hoisted_52 = {
  key: 0,
  class: "add-contact-container"
}

import type { AcContactData } from "@/types/crm"
import AcMediumModal from '@/components/reusable/teleports/acMediumModal.vue'
import ContactModal from '@/components/reusable/contactModal.vue'
import { ref, computed } from 'vue'
import { modalClosed } from '@/mixins/visualFormatters'


export default /*#__PURE__*/_defineComponent({
  __name: 'contactDisplayer',
  props: {
    contactData: {},
    isMultiple: { type: Boolean },
    isEditable: { type: Boolean },
    isDeletable: { type: Boolean },
    showAddButton: { type: Boolean },
    addButtonText: {},
    emptyStateText: {},
    showIcons: { type: Boolean },
    showQrCode: { type: Boolean },
    contactQrTitle: {},
    cols: {}
  },
  emits: ["contactUpdated", "contactDeleted", "contactAdded"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

// Normalize contact data to always be an array
const contacts = computed(() => {
    if (!props.contactData) return []
    return Array.isArray(props.contactData) ? props.contactData : [props.contactData]
})

const isAddingContact = ref(false)
const editingContact = ref<number | null>(null)
const showingQrCode = ref<number | null>(null)

// Contact field icons mapping
/* const fieldIcons = {
    title: '👤',
    emailAddress: '../../assets/icons/mail.png',
    phoneNumber: '../../assets/icons/phone.png',
    address: '../../assets/icons/pin.png',
    website: '../../assets/icons/internet.png'
}
 */
function startEdit(index: number) {
    if (props.isEditable) {
        editingContact.value = index
    }
}

/* function cancelEdit() {
    editingContact.value = null
} */

function deleteContact(contact: AcContactData) {
    emits('contactDeleted', contact)
}

function startAddContact() {
    isAddingContact.value = true
}

function handleContactUpdated(contact: AcContactData, index: number) {
    const originalContact = contacts.value[index]
    editingContact.value = null
    isAddingContact.value = false
    modalClosed()
    emits('contactUpdated', contact, originalContact)
}

function handleNewContactSaved(contact: AcContactData) {
    isAddingContact.value = false
    editingContact.value = null
    emits('contactAdded', contact)
    modalClosed()
}

function displayQrCode(index: number) {
    showingQrCode.value = index
}

function closeQrCode() {
    showingQrCode.value = null
}

// Generate vCard format for QR code
function generateVCard(contact: AcContactData): string {
    const vcard = [
        'BEGIN:VCARD',
        'VERSION:3.0',
        `FN:${contact.title}`,
        `N:${contact.title};;;;`,
    ]

    if (props.contactQrTitle) {
        vcard.push(`ORG:${props.contactQrTitle}`)
    }

    if (contact.emailAddress) {
        vcard.push(`EMAIL:${contact.emailAddress}`)
    }

    if (contact.phoneNumber) {
        vcard.push(`TEL:${contact.phoneNumber}`)
    }

    if (contact.address) {
        vcard.push(`ADR:;;${contact.address};;;;`)
    }

    if (contact.website) {
        vcard.push(`URL:${contact.website}`)
    }

    vcard.push('END:VCARD')
    return vcard.join('\n')
}

// Generate QR code URL using a QR service
function generateQrCodeUrl(contact: AcContactData): string {
    const vcard = generateVCard(contact)
    const encodedVCard = encodeURIComponent(vcard)
    // Using QR Server API for generating QR codes
    return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodedVCard}`
}

// Helper to check if contact has any data
function hasContactInfo(contact: AcContactData): boolean {
    return !!(contact.emailAddress || contact.phoneNumber || contact.address || contact.website)
}

/* // Helper to get display value for field
function getFieldValue(contact: AcContactData, field: keyof AcContactData): string {
    return contact[field] || ''
}

// Helper to get field label
function getFieldLabel(field: keyof AcContactData): string {
    const labels = {
        title: 'İsim/Unvan',
        emailAddress: 'E-posta',
        phoneNumber: 'Telefon',
        address: 'Adres',
        website: 'Website'
    }
    return labels[field] || field
} */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "contact-grid",
      style: _normalizeStyle({ gridTemplateColumns: `repeat(${_ctx.cols || 1}, 1fr)` })
    }, [
      (contacts.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.emptyStateText || "Henüz iletişim bilgisi eklenmemiş."), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contacts.value, (contact, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "contact-item"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", null, _toDisplayString(contact.title), 1)
              ]),
              (_ctx.isEditable || _ctx.isDeletable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.isEditable)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: ($event: any) => (startEdit(index)),
                          class: "action-btn edit-btn",
                          title: 'Düzenle'
                        }, _hoisted_11, 8, _hoisted_9))
                      : _createCommentVNode("", true),
                    (_ctx.isDeletable)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: ($event: any) => (deleteContact(contact)),
                          class: "action-btn delete-btn",
                          title: 'Sil'
                        }, _hoisted_14, 8, _hoisted_12))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (hasContactInfo(contact))
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (contact.emailAddress)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("a", {
                          href: `mailto:${contact.emailAddress}`,
                          class: "field-value email-link"
                        }, _toDisplayString(contact.emailAddress), 9, _hoisted_18)
                      ]))
                    : _createCommentVNode("", true),
                  (contact.phoneNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("a", {
                          href: `tel:${contact.phoneNumber}`,
                          class: "field-value phone-link"
                        }, _toDisplayString(contact.phoneNumber), 9, _hoisted_21)
                      ]))
                    : _createCommentVNode("", true),
                  (contact.website)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("a", {
                          href: contact.website,
                          target: "_blank",
                          class: "field-value website-link"
                        }, _toDisplayString(contact.website), 9, _hoisted_24)
                      ]))
                    : _createCommentVNode("", true),
                  (contact.address)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("span", _hoisted_27, _toDisplayString(contact.address), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30)),
            (_ctx.showQrCode && hasContactInfo(contact))
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (displayQrCode(index)),
                    class: "ac-minimal-button qr-save-btn"
                  }, " Telefona Kaydet ", 8, _hoisted_32)
                ]))
              : _createCommentVNode("", true)
          ]),
          (showingQrCode.value === index)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "qr-overlay",
                onClick: closeQrCode
              }, [
                _createElementVNode("div", {
                  class: "qr-modal",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("h3", null, _toDisplayString(contact.title) + " - İletişim QR Kodu", 1),
                    _createElementVNode("button", {
                      onClick: closeQrCode,
                      class: "close-btn"
                    }, "×")
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("img", {
                        src: generateQrCodeUrl(contact),
                        alt: `${contact.title} QR Code`,
                        class: "qr-code-image"
                      }, null, 8, _hoisted_36)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _hoisted_41,
                            _createTextVNode(" " + _toDisplayString(contact.title), 1)
                          ]),
                          (_ctx.contactQrTitle)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                                _hoisted_43,
                                _createTextVNode(" " + _toDisplayString(_ctx.contactQrTitle), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (contact.emailAddress)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                                _hoisted_45,
                                _createTextVNode(" " + _toDisplayString(contact.emailAddress), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (contact.phoneNumber)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                                _hoisted_47,
                                _createTextVNode(" " + _toDisplayString(contact.phoneNumber), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (contact.address)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                                _hoisted_49,
                                _createTextVNode(" " + _toDisplayString(contact.address), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (contact.website)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_50, [
                                _hoisted_51,
                                _createTextVNode(" " + _toDisplayString(contact.website), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 4),
    (_ctx.showAddButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createElementVNode("button", {
            onClick: startAddContact,
            class: "add-contact-btn"
          }, _toDisplayString(_ctx.addButtonText || "İletişim Bilgisi Ekle"), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingContact.value || editingContact.value !== null)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                width: "50vw",
                height: "80vh",
                onModalClosed: _cache[3] || (_cache[3] = ($event: any) => {isAddingContact.value = false; editingContact.value = null; _unref(modalClosed)()})
              }, {
                default: _withCtx(() => [
                  _createVNode(ContactModal, {
                    "is-visible": isAddingContact.value || editingContact.value !== null,
                    "is-editing": editingContact.value !== null,
                    "existing-contact": editingContact.value !== null ? contacts.value[editingContact.value] : undefined,
                    onClosed: _cache[1] || (_cache[1] = ($event: any) => {isAddingContact.value = false; editingContact.value = null; _unref(modalClosed)()}),
                    onContactSaved: _cache[2] || (_cache[2] = ($event: any) => (editingContact.value !== null ? handleContactUpdated($event, editingContact.value) : handleNewContactSaved($event)))
                  }, null, 8, ["is-visible", "is-editing", "existing-contact"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})